(function ($) {
    // On DOM ready
    $('.column-with-icon .content-wrapper .text-box .text-content').matchHeight();
    $('.column-with-icon .content-wrapper .text-box .text-content h4').matchHeight();
})(jQuery);